/**
 * Rewrites `{{mark…mark}}` → `mark{{…}}mark` where `mark` is `**`, `*`, `***`,
 * or `~~`. Runs before markdown-it tokenizes the input.
 *
 *   `{{**bold**}}`   → `**{{bold}}**`
 *   `{{*italic*}}`   → `*{{italic}}*`
 *   `{{~~strike~~}}` → `~~{{strike}}~~`
 *
 * Code fences and inline code are preserved as-is so literal samples like
 * `` `{{**x**}}` `` keep their braces and stars intact.
 */
export const HIGHLIGHT_MARK_REGEX =
	/```[\s\S]*?```|`[^`\n]+`|\{\{(\*{1,3}|~~)(.+?)\1\}\}/g;

export const normalizeHighlightMarks = (text: string): string =>
	text.replace(HIGHLIGHT_MARK_REGEX, (match, mark, content) => {
		if (match.startsWith("`")) {
			return match;
		}
		return `${mark}{{${content}}}${mark}`;
	});
